// Helper function to get a query parameter from the URL.
function getQueryParam(name) {
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function updateVariantMessage() {
  // Get the current variant from the URL.
  var variant = getQueryParam('variant');
  console.log("Updating variant message. URL variant:", variant);

  if (!variant) {
    // No variant parameter in the URL: hide all, then show the first message immediately.
    $('.variants-message-block-wrapper-each-item').stop(true, true).hide();
    $('.variants-message-block-wrapper-each-item').first().stop(true, true).show();
    return;
  }

  // Find the target message div by filtering elements that have a class matching the variant.
  var $target = $('.variants-message-block-wrapper-each-item').filter(function() {
    return $(this).hasClass(variant);
  }).first();

  // If no matching element is found, fall back to the first message div.
  if (!$target.length) {
    $target = $('.variants-message-block-wrapper-each-item').first();
  }

  // Always hide all message divs first.
  $('.variants-message-block-wrapper-each-item').stop(true, true).hide();

  // Fade in only the target element.
  $target.stop(true, true).fadeIn(300);
}

$(document).ready(function() {
  // On initial page load, update the message.
  updateVariantMessage();

  // When a radio input is clicked, wait a bit for the URL to update then update the message.
  $('fieldset.js input[type="radio"]').on('click', function() {
    setTimeout(function() {
      updateVariantMessage();
    }, 300);
  });

  // --- Part 1: Override pushState/replaceState to trigger a custom event ---
  (function(history) {
    var pushState = history.pushState;
    var replaceState = history.replaceState;

    history.pushState = function() {
      var ret = pushState.apply(history, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return ret;
    };

    history.replaceState = function() {
      var ret = replaceState.apply(history, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return ret;
    };

    window.addEventListener('popstate', function() {
      window.dispatchEvent(new Event('locationchange'));
    });
  })(window.history);

  // Listen for the custom "locationchange" event.
  window.addEventListener('locationchange', function() {
    console.log("Custom locationchange event fired.");
    updateVariantMessage();
  });

  // --- Part 2: Fallback polling mechanism (in case URL changes without firing events) ---
  var lastSearch = window.location.search;
  setInterval(function() {
    if (window.location.search !== lastSearch) {
      lastSearch = window.location.search;
      console.log("Polling detected URL change:", lastSearch);
      updateVariantMessage();
    }
  }, 500);
});












// MOBILE--HAMBURGER--SCRIPT     
jQuery(document).ready(function(){
    $('button.hamburger').click(function(){
        $(this).toggleClass('ham-open')
        $('.mobile-menu').slideToggle();
    });
});

document.addEventListener("DOMContentLoaded", function() {
    let form = document.getElementById("custom-add-to-cart-form");
    let successMessage = document.getElementById("cart-success-message");
    let closeBtn = document.getElementById("close-cart-message");

    form.addEventListener("submit", function(event) {
      event.preventDefault(); // Prevent page reload

      let formData = new FormData(this);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (data.id) {
          successMessage.style.display = "block";
        }
      })
      .catch(error => console.error("Error adding to cart:", error));
    });

    // Close notification when ❌ is clicked
    closeBtn.addEventListener("click", function() {
      successMessage.style.display = "none";
    });
  });

// PRODUCT--SLIDER--SCRIPT
var swiper = new Swiper(".mySwiper", {
      loop: true,
      spaceBetween: 28,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".mySwiper2", {
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      },
    });

$(document).ready(function () {
  $(".mh_prod_tabs-tab").click(function () {
    var tabName = $(this).data("tab");

    // Remove active class from all tabs
    $(".mh_prod_tabs-tab").removeClass("active");
    $(this).addClass("active");

    // Hide all popups & tab content
    $(".mh_prod_tabs-content").removeClass("active");
    $(".mh_prod_tabs-popup").fadeOut();

    if (tabName === "tab1") {
      $("#tab1").addClass("active");
    } else {
      $("#" + tabName).fadeToggle();
    }
  });

  // Close popup when clicking close button
  $(".mh_prod_tabs-close").click(function () {
    $(this).parent().fadeOut();
  });
});


// Check if body has class 'index'
if (document.body.classList.contains('index')) {

    document.getElementById('speaker-kor').addEventListener('click', function() {
  var audio = new Audio(
    'https://cdn.shopify.com/s/files/1/0721/6929/2000/files/Yoli_Yangnyum.m4a?v=1742301810'
  );
  audio.play();
});

    document.getElementById('speaker-eng').addEventListener('click', function() {
        var audioURL2 = "https://cdn.shopify.com/s/files/1/0721/6929/2000/files/Cooking_with_Flavor.m4a?v=1742301941";

        // Play the English audio file directly
        var audio = new Audio(audioURL2);
        audio.play();
    });

}
// // Check if body has class 'index'
// if (document.body.classList.contains('index')) {

//     // LANGUAGE--TRANSLATION--SCRIPT
//     document.getElementById('speaker-kor').addEventListener('click', function() {
//         var koreanText = document.getElementById('korean').textContent;
//         var korEngText = document.getElementById('kor-eng').textContent;
    
//         // Function to speak text
//         function speak(text, lang) {
//             var utterance = new SpeechSynthesisUtterance(text);
//             utterance.lang = lang; // Set the language (Korean for first text, English for second)
//             window.speechSynthesis.speak(utterance);
//         }
    
//         // Speak Korean text first
//         speak(koreanText, 'ko-KR');
    
//         // Wait for the Korean text to finish, then speak English text
//         setTimeout(function() {
//             speak(korEngText, 'en-US');
//         }, 2000); // Adjust the timeout based on the length of the first text
//     });

//     document.getElementById('speaker-eng').addEventListener('click', function() {
//         var EngText = document.getElementById('eng-lan').textContent;

//         // Function to speak text
//         function speak(text, lang) {
//             var utterance = new SpeechSynthesisUtterance(text);
//             utterance.lang = lang; // Set the language to English
//             window.speechSynthesis.speak(utterance);
//         }

//         // Speak English text
//         speak(EngText, 'en-US');
//     });

// }


$(document).ready(function(){
  var $variantSelects = $('#variant-selects-template--19079093190880__main');
  var $variantsMessageBlock = $('div.variants-message-block');
  
  // Check that both elements exist before moving
  if ($variantSelects.length && $variantsMessageBlock.length) {
    $variantSelects.insertBefore($variantsMessageBlock);
  }
});
